import http from "@/settings/apiSettings"

class DrepturiCustomDataService {
    get(): Promise<any> {
        return http.clientAuth.get("/AUTH_DrepturiCustom/GetDrepturiCustom");
    }

    save(data: any): Promise<any> {
        return http.clientAuth.post("/AUTH_DrepturiCustom/AddDrepturiCustom", data);
    }

    update(id: string, data: any): Promise<any> {
        return http.clientAuth.patch(`/AUTH_DrepturiCustom/UpdateDrepturi/${id}`, data);
    }
    delete(id: string): Promise<any> {
        return http.clientAuth.delete(`/AUTH_DrepturiCustom/DeleteDrepturi/${id}`);
    }


}

export default new DrepturiCustomDataService();